"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setIsMoving = exports.create = exports.get = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var crokinoleFlyingPieces_sidecar_1 = require("./crokinoleFlyingPieces-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var largeSprites_1 = require("@sprites/largeSprites");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var crokinoleLayers_sidecar_1 = require("@crokinole/scene/crokinoleLayers-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var namespace = 'crokinole_background';
var verbose = false;
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    assert_sidecar_1.assert.notNil(_obj);
    return _obj;
}
exports.get = get;
function create() {
    return {
        color1: diveColors_1.diveColors.darkBlue,
        color2: diveColors_1.diveColors.lightBlue,
        mode: 'snowflakes',
        sprite: null,
    };
}
exports.create = create;
function setIsMoving(isMoving) {
    crokinoleFlyingPieces_sidecar_1.crokinoleFlyingPieces.setIsMoving(isMoving);
}
exports.setIsMoving = setIsMoving;
var update = function () {
    var obj = get();
    var mode = obj.mode;
    common_sidecar_1.common.setBackgroundColor(obj.color1);
    if (obj.sprite) {
        obj.sprite.visible = false;
    }
    var setBackgroundImage = function (ls) {
        if (!obj.sprite) {
            obj.sprite = spritesUtil_sidecar_1.spritesUtil.createLargeSprite(crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().background, largeSprites_1.largeSprites.backLizardScales);
        }
        else {
            spritesUtil_sidecar_1.spritesUtil.setLargeSprite(obj.sprite, ls);
        }
        var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
        var maxSize = mathUtils_sidecar_1.mathUtils.max(gb.width, gb.height);
        var scale = maxSize / obj.sprite.width;
        if (scale < 1) {
            scale = 1;
        }
        obj.sprite.scale = scale;
        obj.sprite.visible = true;
        obj.sprite.tint = obj.color2;
        obj.sprite.alpha = 0.5;
    };
    if (mode === 'flying-pieces') {
        crokinoleFlyingPieces_sidecar_1.crokinoleFlyingPieces.update();
    }
    if (mode === 'snowflakes') {
        setBackgroundImage(largeSprites_1.largeSprites.backSnowflakes);
    }
    if (mode === 'lizard-scales') {
        setBackgroundImage(largeSprites_1.largeSprites.backLizardScales);
    }
};
exports.update = update;
